module.exports = __webpack_public_path__ + "img/136.4.dea12196.png";